import React from "react"
import { faBan, faCheckCircle, faFile } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faText } from "@fortawesome/pro-solid-svg-icons"

import ButtonPrimary from "components/ButtonPrimary"

import { Form, Input } from 'antd'

import styles from "./styles.module.scss"

const ReportDetailsForm = ({ report, onSave, onCancel }) => {

  const _getInitialValues = () => {
    return {
      reportName: report?.name || '',
      description: report?.description || ''
    }
  }

  let classes = styles.addCase__formContainer

  return (
    <Form
      name="basic"
      initialValues={{ ..._getInitialValues(), remember: true }}
      layout="vertical"
      onFinish={onSave}
      autoSize="true"
    >
      <div className={classes}>
        <div className={styles.addCase__small}>
          <span><FontAwesomeIcon icon={faFile} /></span>
          <Form.Item label="Report Name" name="reportName" rules={[{ required: true, message: 'Please add a Report Name' }]}>
            <Input id="reportName" />
          </Form.Item>
        </div>
        <div className={styles.addCase__small}>
          <span><FontAwesomeIcon icon={faText} /></span>
          <Form.Item label="Report Description" name="description">
            <Input.TextArea id="description" autoSize={{ minRows: 2, maxRows: 6 }} />
          </Form.Item>
        </div>
      </div>
      <div className={styles.actions__container}>
        <div className={styles.actions}>
          <ButtonPrimary small type="button" color="grey" icon={faBan} onClick={onCancel}>Cancel</ButtonPrimary>
          <ButtonPrimary small color="navy" icon={faCheckCircle}>Save</ButtonPrimary>
        </div>
      </div>
    </Form>
  )
}

export default ReportDetailsForm
